<script setup lang="ts">
import { useI18n } from 'vue-i18n';
import { useJobBoardStore } from '@/core/collections/job-boards/job-board.store';
import MediaSelector from '@/core/components/form-elements/MediaSelector.vue';

const { locale } = useI18n();
const jobBoardStore = useJobBoardStore();

defineProps<{
   jobBoardId: number;
}>();
</script>

<template>
   <div class="category-image-settings">
      <div class="category-image-settings__grid">
         <div v-for="jobCategory in jobBoardStore.categories" :key="jobCategory.id" class="category-image-settings__item">
            <h3>{{ jobCategory.name[locale] }}</h3>
            <MediaSelector v-model="jobCategory.image_url" v-model:media-id="jobCategory.image_id" :id="jobBoardId" />
         </div>
      </div>
   </div>
</template>

<style scoped lang="scss">
.category-image-settings {
   &__grid {
      display: grid;
      grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));
      gap: var(--nxt-gutter);
   }

   &__item {
      display: flex;
      flex-direction: column;
      gap: var(--nxt-gutter-small);
   }

   h3 {
      font-weight: 600;
      font-size: 1rem;
      margin: 0;
      border-bottom: 1px solid var(--nxt-dark);
   }
}
</style>
